import { render, staticRenderFns } from "./ReminderNoteComponent.vue?vue&type=template&id=52c414f9&scoped=true"
import script from "./ReminderNoteComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReminderNoteComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ReminderNoteComponent.vue?vue&type=style&index=0&id=52c414f9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c414f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c414f9')) {
      api.createRecord('52c414f9', component.options)
    } else {
      api.reload('52c414f9', component.options)
    }
    module.hot.accept("./ReminderNoteComponent.vue?vue&type=template&id=52c414f9&scoped=true", function () {
      api.rerender('52c414f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientReminderNotes/ReminderNoteComponent.vue"
export default component.exports